<template>
  <div class="sales-manage">
    <div class="sales-header">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="机构名称">
                <a-input
                  placeholder="请输入机构名称"
                  v-model="queryParam.organizationName"
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="机构类型">
                <j-dict-select-tag
                  :placeholder="'请选择机构类型'"
                  type="list"
                  v-model="queryParam.organizationType"
                  dictCode="organization_type"
                />
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <span
                style="float: left; overflow: hidden"
                class="table-page-search-submitButtons"
              >
                <a-button type="primary" @click="searchQuery" icon="search"
                  >查询</a-button
                >
                <a-button
                  type="primary"
                  @click="searchReset"
                  icon="reload"
                  style="margin-left: 8px"
                  >重置</a-button
                >
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="mg">
        <!--返回产品页面-->
        <a-button type="primary" icon="plus" @click="handleAdd">
          新增
        </a-button>
        <a-button @click="showDialog = true" type="primary" icon="upload"
          >导入</a-button
        >

        <a-button @click="exportOrganizationAll" type="primary"
          >导出全部销售机构</a-button
        >
        <a-dropdown v-if="selectedRowKeys.length > 0">
          <a-menu slot="overlay">
            <a-menu-item @click="batchDel"
              ><a-icon type="primary" />批量删除</a-menu-item
            >
          </a-menu>
          <a-button style="margin-left: 8px">
            批量操作 <a-icon type="down"
          /></a-button>
        </a-dropdown>
      </div>
    </div>
    <!-- 导入 -->
    <a-modal
      title="上传文件"
      :visible="showDialog"
      @cancel="showDialog = false"
    >
      <a-upload-dragger
        name="file"
        :multiple="true"
        :file-list="fileList"
        accept=".xls,.xlsx"
        :before-upload="beforeUpload"
        :remove="handleRemove"
      >
        <p class="ant-upload-drag-icon">
          <a-icon type="inbox" />
        </p>
        <p class="ant-upload-text">点击或拖拽上传文件</p>
      </a-upload-dragger>
      <p
        @click="falling('销售网点')"
        style="float: right; margin-top: 0px; cursor: pointer; color: #1890ff"
      >
        点击下载模板
      </p>
      <template slot="footer">
        <a-button key="back" @click="showDialog = false"> 取消 </a-button>
        <a-button
          :disabled="fileList.length === 0"
          :loading="uploading"
          key="submit"
          type="primary"
          icon="download"
          @click="upload"
        >
          导入
        </a-button>
      </template>
    </a-modal>
    <a-table
      ref="tableSelect"
      bordered
      rowKey="id"
      :columns="columns"
      :data-source="dataSource"
      :loading="loading"
      :rowSelection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange
      }"
      :pagination="ipagination"
      class="j-table-force-nowrap"
      @change="handleTableChange"
    >
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑 </a>
        <a-divider type="vertical" />
        <a @click="handleDelete(record.id)">删除</a>
      </span>
    </a-table>
    <sales-organizetion-modal
      ref="modalForm"
      @ok="modalFormOk"
    ></sales-organizetion-modal>
  </div>
</template>
<script>
import { downloadFile, uploadAction, downFile } from '@/api/manage.js';
import '@/assets/less/TableExpand.less';
import SalesOrganizetionModal from './modules/SalesOrganizetionModal';
import JDictSelectTag from '@/components/dict/JDictSelectTag.vue';
import { getListData, deleteBatch, deleteById } from '@/api/organization.js';

const columns = [
  {
    title: '机构名称',
    dataIndex: 'name',
    align: 'center',
    key: 'organizationName',
    width: 150
  },
  {
    title: '机构类型',
    dataIndex: 'organizationType_dictText',
    align: 'center',
    width: 150,
    customRender: text => {
      return !text || text == '' ? '--' : text;
    }
  },
  {
    title: '客服电话',
    dataIndex: 'mobile',
    key: 'mobile',
    align: 'center',
    width: 200
  },
  {
    title: '网址',
    dataIndex: 'web',
    align: 'center',
    width: 200
  },
  {
    title: '操作',
    dataIndex: '',
    width: 150,
    align: 'center',
    scopedSlots: { customRender: 'action' }
  }
];

export default {
  name: 'SalesOrganization',
  components: {
    JDictSelectTag,
    SalesOrganizetionModal
  },
  data() {
    return {
      showDialog: false,
      uploading: false,
      fundCode: '',
      routerFundCode: '',
      pageSize: 10,
      current: 1,
      confirmLoading: false,
      columns,
      selectedRowKeys: [],
      dataSource: [],
      fileList: [],
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      queryParam: {
        organizationName: '',
        organizationType: ''
      },
      selectedRowKeys: [],
      selectionRows: [],
      isorter: {
        column: 'createTime'
        // order: 'desc',
      },
      url: {
        list: process.env.VUE_APP_CMS_PRODUCT + '/product/organization/list',
        delete:
          process.env.VUE_APP_CMS_PRODUCT +
          '/product/productsOrganization/delete',
        deleteBatch:
          process.env.VUE_APP_CMS_PRODUCT +
          '/product/productsOrganization/deleteBatch',
        exportXlsUrl:
          process.env.VUE_APP_CMS_PRODUCT +
          '/product/productsOrganization/exportXls',
        importExcelUrl:
          process.env.VUE_APP_CMS_PRODUCT +
          '/product/productsOrganization/importExcel',
        importTableUrl:
          process.env.VUE_APP_CMS_PRODUCT + '/product/organization/importExcel',
        exportsUrl:
          process.env.VUE_APP_CMS_PRODUCT +
          '/product/organization/downExcelTemplate' //导入模板
      },
      loading: false
    };
  },
  computed: {
    importExcelUrl: function() {
      return `${process.env.VUE_APP_GATEWAY_URL}${this.url.importExcelUrl}`;
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    handleOk() {},
    reset() {
      this.fundCode = '';
    },
    handleImportExcel() {},
    upload() {
      this.showDialog = false;
    },
    exportOrganization() {
      let formdata = new FormData();
      formdata.append('ids', this.selectedRowKeys.join(','));
      downloadFile(
        process.env.VUE_APP_CMS_PRODUCT +
          '/product/productsOrganization/exportOrganization',
        '销售机构.xls',
        formdata
      ).then(res => {});
    },
    exportOrganizationAll() {
      downloadFile(
        process.env.VUE_APP_CMS_PRODUCT +
          '/product/organization/exportOrganizationAll',
        '销售机构.xls'
      ).then(res => {});
    },
    //查询
    getList(arg) {
      let that = this;
      if (arg === 1) {
        that.ipagination.current = 1;
      }
      let params = {
        pageSize: that.ipagination.pageSize,
        pageNo: that.ipagination.current,
        name: that.queryParam.organizationName,
        organizationType: that.queryParam.organizationType
      };
      that.loading = true;
      getListData(params).then(res => {
        that.loading = false;
        if (res.success) {
          that.dataSource =
            res.result && res.result.records ? res.result.records : [];
          that.ipagination.total = res.result.total;
        } else {
          that.$message.error(res.message);
        }
      });
    },
    // 获取点中时的数据
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
    },
    //添加
    handleAdd: function(course) {
      if (course) {
        if (course.type == 'click') {
          course = undefined;
        }
      }
      this.$refs.modalForm.add(course);
      this.$refs.modalForm.title = '新增';
      this.$refs.modalForm.disableSubmit = false;
    },
    //获取查询条件
    getQueryParams() {
      let sqp = {};
      let param = Object.assign(sqp, this.queryParam, this.isorter);
      param.field = this.getQueryField();
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      return param; //filterObj(param);
    },
    // 编辑
    handleEdit(record) {
      console.log(record);
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = '编辑';
      this.$refs.modalForm.disableSubmit = false;
    },
    getQueryField() {
      var str = 'id,';
      this.columns.forEach(function(value) {
        str += ',' + value.dataIndex;
      });
      return str;
    },
    //批量删除
    batchDel() {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        let ids = this.selectedRowKeys.join(',');
        var that = this;
        this.$confirm({
          title: '确认删除',
          content: '是否删除选中数据?',
          onOk: function() {
            that.loading = true;
            let formData = new FormData();
            formData.append('ids', ids);
            deleteBatch(formData).then(res => {
              that.loading = false;
              if (res.success) {
                that.$message.success(res.message);
                that.getList();
                that.onClearSelected();
              } else {
                that.$message.warning(res.message);
              }
            });
          }
        });
      }
    },
    modalFormOk() {
      // 新增/修改 成功时，重载列表
      this.getList();
    },
    //删除
    handleDelete(id) {
      let that = this;
      that.$confirm({
        title: '确认删除',
        content: '确定要删除吗',
        onOk: function() {
          that.loading = true;
          let formData = new FormData();
          formData.append('id', id);
          deleteById(formData).then(res => {
            that.loading = false;
            if (res.success) {
              that.getList(1);
              that.$message.success(res.message);
            } else {
              that.$message.error(res.message);
            }
          });
        }
      });
    },
    //查询
    searchQuery() {
      this.getList(1);
    },
    //重置
    searchReset() {
      this.queryParam = {};
      if (this.$route.query.type != 4) {
        this.getList(1);
      }
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected(); //分页切换时清空表格选中
      //分页、排序、筛选变化时触发
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
      }
      this.ipagination = pagination;
      this.getList();
    },
    // 文件上传
    beforeUpload(file) {
      this.fileList = [file];
      console.log(this.fileList);
      return false;
    },
    // 删除文件
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    upload() {
      let formData = new FormData();
      this.uploading = true;
      formData.set('file', this.fileList[0]);

      uploadAction(this.url.importTableUrl, formData)
        .then(res => {
          if (res.success) {
            this.$message.success(res.message);
          } else {
            this.$message.error(res.message);
          }
        })
        .finally(() => {
          this.uploading = false;
          this.fileList = [];
          this.showDialog = false;
          this.searchQuery();
        });
    },
    //点击下载模板
    falling(fileName) {
      downFile(this.url.exportsUrl, { selections: '' }).then(data => {
        if (!data) {
          this.$message.warning('文件下载失败');
          return;
        }
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(
            new Blob([data], { type: 'application/vnd.ms-excel' }),
            fileName + '.xls'
          );
        } else {
          let url = window.URL.createObjectURL(
            new Blob([data], { type: 'application/vnd.ms-excel' })
          );
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', fileName + '.xls');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); //下载完成移除元素
          window.URL.revokeObjectURL(url); //释放掉blob对象
          this.searchQuery();
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.sales-manage {
  background: #fff;
  padding: 25px;
  .sales-header {
    margin-bottom: 20px;
    .mg {
      margin: 20px 0;
    }
    button {
      margin-right: 10px;
    }
    .select-container {
      span {
        margin-right: 15px;
      }
    }
  }
}
</style>
